module.exports = __webpack_public_path__ + "5cb4648809fd99225855b7892e00cd42.MP3";